package com.essntl.core.stripe.domain.models

import kotlinx.serialization.Serializable

data class PaymentLink(
    val id: String,
    val url: String,
    val active: Boolean,
    val metadata: Metadata? = null,
) {
    @Serializable
    data class Metadata(
        val client: String?,
        val travelAgent: String?,
        val product: String,
        val proposal: String?,
        val invoiceId: String?,
        val qbInvoiceId: String?,
    )
}
